/**
 * 指定されたクラス名が除外クラスに含まれているかをチェックする関数
 * @function isExcludedClasses
 * @param {string[]} classes - チェックするクラス名の配列
 * @returns {boolean} - 除外クラスに含まれているかどうか
 */
export function isExcludedClasses(classes) {
    return classes.some((className) => {
        return document.querySelector(className) !== null;
    });
}
/**
 * 与えられた要素からNodeListを作成する関数
 * @function convertArrayToNodeList
 * @param {...Element} elements - NodeListに含める要素
 * @returns {NodeListOf<Element>} - 作成されたNodeList
 */
export function convertArrayToNodeList(elements) {
    return {
        length: elements.length,
        item: (index) => elements[index] || null,
        forEach(callback) {
            elements.forEach((element, index) => {
                callback(element, index, this);
            });
        },
        [Symbol.iterator]: function* () {
            yield* elements;
        },
    };
}
/**
 * 全角文字を半角文字に変換する関数。
 * @function toHalfWidth
 * @param {string} strVal - 全角文字を含む文字列。
 * @returns {string} - 全角文字が半角文字に置き換えられた文字列。
 */
export function toHalfWidth(strVal) {
    const fullWidth = "０１２３４５６７８９ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ！”＃＄％＆’（）＊＋，ー．／：；＜＝＞？＠［＼］＾＿‘｛｜｝～";
    const halfWidth = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
    return strVal
        .split("")
        .map((char) => {
        const index = fullWidth.indexOf(char);
        return index !== -1 ? halfWidth[index] : char;
    })
        .join("");
}
//# sourceMappingURL=utility.js.map